import { render } from "./GPCRExperienceListPanel.vue?vue&type=template&id=b8aff1be"
import script from "./GPCRExperienceListPanel.vue?vue&type=script&lang=js"
export * from "./GPCRExperienceListPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__